import type {DoppeHideableValue} from './doppe-hideable-value';
import {doppeHideableValueCreateHidden, doppeHideableValueModifyValue} from './doppe-hideable-value';
import type {DoppeDtoBymoSubscribeListId} from './doppe-dto-bymo-subscribe-list';
import type {Values} from '@wix/devzai-utils-common';
import {evaluateFunction} from '@wix/devzai-utils-common';
import {doppeDtoUserResolveContactsMetaSiteId} from './doppe-dto-user';
import type {DoppeDtoAccountData} from './doppe-dto-account-data';


export const DoppeFormActionCrmType = {
    WixCrm: 'WixCrm',
    HoppCrm: 'Hopp',
    WixAndHoppCrm: 'WixAndHopp',
    Auto: 'Auto',
} as const;

export type DoppeFormActionCrmType = Values<typeof DoppeFormActionCrmType>;

export interface DoppeFormActionSettings extends DoppeDeperecatedFormActionSettings {
    crmType: DoppeFormActionCrmType;
    creatorsListId: DoppeDtoBymoSubscribeListId[];
    linkedWixSiteListId: DoppeDtoBymoSubscribeListId[];
    showConsentCheckbox: boolean;
    customConsentText: DoppeHideableValue<string>;
    customThankYouMessage: DoppeHideableValue<string>;
    withEmailNotification: boolean;
    customEmailForNotifications: DoppeHideableValue<string>;
}

export interface DoppeDeperecatedFormActionSettings {
    listId: DoppeDtoBymoSubscribeListId | null;
}




export function getDefaultDoppeFormActionSettings(overrides?: Partial<DoppeFormActionSettings>) {
    return {
        crmType: DoppeFormActionCrmType.Auto,
        creatorsListId: [],
        linkedWixSiteListId: [],
        showConsentCheckbox: false,
        customConsentText: doppeHideableValueCreateHidden(''),
        listId: null,
        withEmailNotification: true,
        customThankYouMessage: doppeHideableValueCreateHidden(''),
        customEmailForNotifications: doppeHideableValueCreateHidden(''),
        ...overrides
    } satisfies DoppeFormActionSettings
}

export function doppeFormActionSettingsResolveDefaultCrmType(
    currentAccount: DoppeDtoAccountData.WithExtendedData | undefined
): DoppeFormActionCrmType {
    return evaluateFunction(() => {
        // Default to Hopp only
        if (!currentAccount || !currentAccount.wixUserId || !currentAccount.wixMetaSiteId || !currentAccount.creatorsWixMetaSiteId) {
            return DoppeFormActionCrmType.HoppCrm;
        }
        
        // Check if Wix CRM is connected and resolvable
        const canResolveWixCrm = doppeDtoUserResolveContactsMetaSiteId(currentAccount as any);
        if (canResolveWixCrm) {
            return DoppeFormActionCrmType.WixAndHoppCrm; // Use both if Wix CRM is connected
        }
        
        return DoppeFormActionCrmType.HoppCrm; // Fallback to Hopp only
    });
}



export function prepareFormSettingsForViewer (settings: DoppeFormActionSettings) {
    doppeHideableValueModifyValue(settings.customEmailForNotifications, '')
}
